import { FileStatusModel } from "../models/file-status";
import { backboneCollectionProperties } from "../../decorators/backbone-properties";

@backboneCollectionProperties({
    model: FileStatusModel
})
export class FileStatusCollection extends Backbone.Collection<FileStatusModel> {
    constructor(options?) {
        super(options);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/import-status/collections/file-status.ts